export default __webpack_public_path__ + "static/media/generic.d1751a91.png";